<template>
  <div class="page">
    <div class="top-content">
      <div class="title">佰医汇-中卫佰医</div>
      <div class="content">
        此处维护与本商户有交易往来、后续涉及到分账的其它商户，此商户关系会作为分账规则设置的依据，可维护多个商户，已维护的商户信息可修改、删除，请谨慎操作。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MTip',
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.top-content {
  background-color: #fff;
  font-size: 14px;
  padding: 15px 20px;
  border-radius: 5px;
  .title {
    color: #333;
  }
  .content {
    color: #666;
    margin-top: 10px;
    line-height: 20px;
  }
}
</style>
